import { CSSObject } from "@emotion/react";

import { typographyStyles, constants } from "@newsela/angelou";

const { ui } = constants.colors;

const { fontSize } = typographyStyles;

const textStyles: CSSObject = {
  textAlign: "left",
  ...fontSize.textM,
  ...typographyStyles.fontFamily.circular,
};

export const buttonRoot: CSSObject = {
  width: "100%",
  display: "grid",
  gridTemplateColumns: "1fr auto",

  border: "none",
  borderRadius: 0,
  padding: "1em",
  paddingBottom: "1em",
  h3: {
    ...textStyles,
    margin: 0,
    fontWeight: 400,
    color: ui.neutral[700],
    // This will allow users to copy the collapse trigger text
    userSelect: "text",
  },
  button: {
    margin: 0,
  },
};

export const collapseContent: CSSObject = {
  padding: "0.875em 0",
};

export const collapseRoot: CSSObject = {
  ...textStyles,
  backgroundColor: ui.neutral[25],
  color: ui.neutral[500],
  padding: 0,
  marginTop: "0.5em",
  "div:nth-of-type(2)": {
    paddingLeft: "1em",
    paddingRight: "1em",
  },
};

export const contentRoot: CSSObject = {
  ...buttonRoot,
  paddingBottom: "1em",
  backgroundColor: ui.neutral[25],
};
